var _path, _ellipse, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChurch2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M504 443L504 471",
    stroke: "#F2DCCE",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 504.5,
    cy: 438.333,
    rx: 16.5,
    ry: 16.3333,
    fill: "#F2DCCE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M499.987 438.19C499.987 434.283 503.288 431.117 507.358 431.117C507.943 431.117 508.511 431.184 509.056 431.308C507.742 430.48 506.187 430 504.519 430C499.814 430 496 433.806 496 438.5C496 443.194 499.814 447 504.519 447C506.814 447 508.895 446.093 510.427 444.62C509.492 445.032 508.454 445.263 507.358 445.263C503.288 445.263 499.987 442.096 499.987 438.19Z",
    fill: "#CC7D61"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M513.402 437.6L513.37 435.146L511.535 436.719L509.304 436.056L510.112 438.337L508.765 440.381L511.1 440.218L512.499 442.144L513.133 439.763L515.345 438.909L513.402 437.6Z",
    fill: "#CC7D61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChurch2);
export default __webpack_public_path__ + "static/media/church_2.9ac0f74dd42460254fbb7fd2b5ac62e9.svg";
export { ForwardRef as ReactComponent };